import { Link } from 'react-router-dom';
import RegisterLink from '@/components/ui/RegisterLink';

export default function BlogCtaSection() {
  return (
    <section
      className="relative py-12 sm:py-16 px-4 sm:px-5 md:px-8 overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #091520 0%, #0d1117 100%)' }}
      aria-labelledby="blog-cta-heading"
    >
      <div className="section-divider absolute top-0 left-0 w-full" />
      <div className="relative max-w-5xl mx-auto">
        <div
          className="glass-card rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 flex flex-col md:flex-row md:items-center gap-6 sm:gap-8"
          style={{ border: '1px solid rgba(71,202,241,0.15)' }}
        >
          <div className="flex-1">
            <div className="badge-blue mb-4 w-fit">
              <i className="ri-book-open-line" aria-hidden />
              Blog
            </div>
            <h2 id="blog-cta-heading" className="text-xl sm:text-2xl md:text-3xl font-black text-white mb-3">
              Notes for Australian players
            </h2>
            <p className="text-[#56626B] text-sm md:text-base leading-relaxed">
              We wrote about <strong className="text-white">Trusted Pokies Australia (TPA)</strong> as a review body, how Bybid9 fits after TPA&apos;s audit programme,
              what football bet does to betting traffic,
              and what studios such as <strong className="text-white">JILI</strong>, <strong className="text-white">BNG</strong>,{' '}
              <strong className="text-white">Pragmatic Play</strong>, <strong className="text-white">VPower</strong>,{' '}
              <strong className="text-white">MEGA888</strong> and <strong className="text-white">BT Gaming</strong> usually signal.
              There is also a short checklist and FAQ before you fund a wallet.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0 w-full md:w-auto">
            <Link to="/blog" className="btn-premium text-sm px-8 py-3.5 min-h-[48px] text-center justify-center w-full sm:w-auto inline-flex items-center">
              <span>Read the full article</span>
            </Link>
            <RegisterLink section="blog_cta" linkLabel="Promotions" href="https://bybid9.tips/RFLANDINGPAGESEO" target="_blank" rel="noreferrer" className="btn-outline-premium text-sm px-8 py-3.5 min-h-[48px] text-center justify-center w-full sm:w-auto inline-flex items-center">
              Promotions
            </RegisterLink>
          </div>
        </div>
      </div>
    </section>
  );
}
